import stepStyles from "../../SelectProperty/SelectPropertyTypePage.module.css";

export const CommercialRentRollStepPage = () => {
  return (
    <>
      <div className={stepStyles.wearDescription}>
        Upload a rent roll for your property. This is a list of all the rentable units in your
        property and their monthly rent. This is an optional step and can be skipped if you do not
        have any rent roll to upload.
      </div>

      <div className={stepStyles.wearExamplesCard}>
        <div className={stepStyles.wearExamplesTitle}>Examples of what to upload:</div>
        <ul className={stepStyles.wearExamplesList}>
          <li>Photos of the property</li>
          <li>Repair/maintenance documents</li>
          <li>Inspection reports</li>
          <li>Supporting paperwork</li>
        </ul>
      </div>
    </>
  );
};
